import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import kebabCase from 'lodash/kebabCase.js';
import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { i18n } from '../../i18n/translate.js';
import { Slugify } from '../../utils/StringUtil.js';
import { Button } from '../Button/index.js';
import { copyToClipboard } from './utils.js';
import { FAIcon } from '../fa-icon/component.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var IconCategoryValue = function IconCategoryValue(props) {
  var category = props.category,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      copyValue = props.copyValue,
      _props$dataAttributes = props.dataAttributesForEdit,
      dataAttributesForEdit = _props$dataAttributes === void 0 ? {} : _props$dataAttributes,
      editAction = props.editAction,
      icon = props.icon,
      iconProps = props.iconProps,
      linkValues = props.linkValues,
      tooltip = props.tooltip,
      _props$tooltipPlaceme = props.tooltipPlacement,
      tooltipPlacement = _props$tooltipPlaceme === void 0 ? 'right' : _props$tooltipPlaceme,
      _props$type = props.type,
      type = _props$type === void 0 ? 'inline' : _props$type,
      url = props.url,
      value = props.value;
  var dataAtrName = value ? "".concat(kebabCase(String(value)), "-icon-category-value") : 'icon-category-value';
  var dataAttributes = pickDataAttributes(props, dataAtrName);

  var renderLinkValues = function renderLinkValues() {
    if (!linkValues) return;

    var getNewWindowProps = function getNewWindowProps(link) {
      if (link !== null && link !== void 0 && link.newWindow) return {
        target: '_blank',
        rel: 'noopener noreferrer'
      };
      return {};
    };

    if (Array.isArray(linkValues)) {
      return linkValues.map(function (link, index) {
        var newWindowProps = getNewWindowProps(link);
        var isLastLink = index === linkValues.length - 1;
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: "link-".concat(index)
        }, /*#__PURE__*/React.createElement("a", _extends({
          href: link.url
        }, newWindowProps), link.label ? link.label : link.url, " ", link.newWindow && /*#__PURE__*/React.createElement(FAIcon, {
          icon: "arrow-up-right-from-square"
        })), !isLastLink && ', ');
      });
    }

    var newWindowProps = getNewWindowProps(linkValues);
    return /*#__PURE__*/React.createElement("a", _extends({
      href: linkValues.url
    }, newWindowProps), linkValues.label ? linkValues.label : linkValues.url);
  };

  return /*#__PURE__*/React.createElement("div", _extends({}, dataAttributes, {
    className: _formatClassName(['icon-category-value', "".concat(type, "-icon-category-value"), "".concat(color, "-icon-category-value"), className])
  }), icon && /*#__PURE__*/React.createElement(FAIcon, _extends({}, iconProps, {
    additionalClasses: "icon",
    icon: icon
  })), /*#__PURE__*/React.createElement("span", {
    className: "category-value"
  }, category && /*#__PURE__*/React.createElement("span", {
    className: _formatClassName(['category', 'bold', "".concat(type, "-category")])
  }, category), type === 'stacked' &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(ButtonElements, {
    copyValue: copyValue,
    tooltip: tooltip,
    tooltipPlacement: tooltipPlacement,
    editAction: editAction,
    dataAttributesForEdit: dataAttributesForEdit,
    category: category,
    value: value
  }), /*#__PURE__*/React.createElement("span", {
    className: _formatClassName(['value', "".concat(type, "-value")])
  }, url ? /*#__PURE__*/React.createElement("a", {
    href: url
  }, value || url) : Array.isArray(value) ? value.join(', ') : value, linkValues && renderLinkValues(), type === 'inline' &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(ButtonElements, {
    copyValue: copyValue,
    tooltip: tooltip,
    tooltipPlacement: tooltipPlacement,
    editAction: editAction,
    dataAttributesForEdit: dataAttributesForEdit,
    category: category,
    value: value
  }))));
};

IconCategoryValue.displayName = "IconCategoryValue";

var ButtonElements = function ButtonElements(props) {
  var copyValue = props.copyValue,
      tooltip = props.tooltip,
      tooltipPlacement = props.tooltipPlacement,
      editAction = props.editAction,
      dataAttributesForEdit = props.dataAttributesForEdit,
      category = props.category,
      value = props.value;
  var overlay = /*#__PURE__*/React.createElement(Popover, {
    id: "tooltip-".concat(Slugify(category || value))
  }, /*#__PURE__*/React.createElement(Popover.Body, null, tooltip));
  return /*#__PURE__*/React.createElement(React.Fragment, null, copyValue && /*#__PURE__*/React.createElement(Button, {
    className: "m-l-5",
    icon: "copy",
    onClick: function onClick() {
      return copyToClipboard(copyValue);
    },
    style: "link",
    renderAsLegacy: true
  }), tooltip && /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: tooltipPlacement,
    transition: false,
    trigger: ['hover', 'focus'],
    overlay: overlay
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    className: "info",
    style: "link",
    icon: "info-circle",
    renderAsLegacy: true
  }))), editAction && /*#__PURE__*/React.createElement(Button, _extends({}, dataAttributesForEdit, {
    className: "edit",
    style: "link",
    icon: "pen",
    label: i18n.t('Edit'),
    onClick: editAction
  })));
};

export { ButtonElements, IconCategoryValue };